import { render, staticRenderFns } from "./initForm.vue?vue&type=template&id=25908214&"
import script from "./initForm.vue?vue&type=script&lang=js&"
export * from "./initForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports